import React, {useEffect, useState} from 'react';
import {
   Animated,
   Dimensions,
   FlatList,
   Platform,
   StyleSheet,
   Text,
   View,
} from 'react-native';
import {useIsFocused, useNavigation} from '@react-navigation/native';
import {useDispatch, useSelector} from 'react-redux';
import {
   All,
   AUTHDATA,
   base100,
   DASHBOARD,
   MYTRAINING,
   BROUS,
   PROFILE,
   VALID,
   white,
   FONT_FAMILY_REGULAR,
   getNorcatId,
   getQRCode,
   isNewAPI,
   TRAINING_IBT_RECORDS,
   IBTRecords,
   ExternalRecords,
   ThirdPartyRecords,
   TrainingOJTRecords,
   TRAINING_OJT_RECORDS,
   TRAINING_THIRDPARTY_RECORDS,
   TRAINING_EXTERNAL_RECORDS,
   VIEWALL,
   VIEWVALID,
   appBackgroundWhiteBG,
   isWeb,
   TRAINING_ALL_RECORDS,
   TrainingAllRecords,
} from '../../utils/utils';
import {retrieveAppData} from '../../utils/preference';
import {ApplicationHeader} from '../../utils/application_header';
import {
   selectScreenOrientation,
   selectLandscapeSmallWebView,
} from '../../redux/slices/ScreenOrientationSlice';
import Landscap_Application_Header from '../../utils/Landscap_Application_Header';
import DashboardHeaderLandsacap from '../dashboard/DashboardHeaderLandsacap';
import DashboardRightPanel from '../dashboard/DashboardRightPanel';
import ProfileHeader from '../profile/ProfileHeader';
import {setUserRecord} from '../../redux/slices/UserRecordSlice';
import MyTrainingItem from './MyTrainingItem';
import {selectAuthData} from '../../redux/slices/AuthSlice';
import logger from '../../utils/logger';
import {
   apiPostRequest,
   showTokenExpireAlertWeb,
} from '../../service/network_access';
import {
   getSelectedTrainingRecord,
   getTrAuthData,
   getTrIsValidRecord,
   getTrPageReLoad,
   getTrainingListData,
   setSelectedTrainingRecord,
   setTrAuthData,
   setTrIsValidRecord,
   setTrainingListData,
} from '../../redux/slices/MyTrainingRecordSlice';
import {ContainerWrapper} from '../../components/common';

const MyTrainingScreen = () => {
   const isTrPageReload = useSelector(getTrPageReLoad);
   const trainingListData = useSelector(getTrainingListData);
   const mAuthData = useSelector(getTrAuthData);
   const isValidRecord = useSelector(getTrIsValidRecord);
   const noNeedToPageRefresh = !isTrPageReload && Platform.OS == 'windows';
   const navigation = useNavigation();
   const isLandscapemode = useSelector(selectScreenOrientation);
   const [checked, setChecked] = useState(false);
   const [showView, setShowView] = useState(false);
   const [animatedValue] = useState(new Animated.Value(-2000));
   const isScreenFocused = useIsFocused();

   const windowHeight = isWeb
      ? window.innerHeight
      : Dimensions.get('window').height;
   const advtsHeight =
      windowHeight < 780
         ? // Medium size Desktop/Tablet
           windowHeight < 680
            ? windowHeight < 600
               ? windowHeight * 0.56
               : windowHeight * 0.625
            : windowHeight < 701
            ? windowHeight * 0.64
            : windowHeight < 750
            ? windowHeight * 0.675
            : windowHeight * 0.65
         : // Large size Desktop
         windowHeight > 1000
         ? windowHeight * 0.75
         : windowHeight * 0.7;

   const [traningList, setTraningList] = useState(
      noNeedToPageRefresh
         ? isValidRecord == VALID
            ? trainingListData.filter(data =>
                 isNewAPI ? data.IsValid : data.isValid,
              )
            : trainingListData
         : [],
   );
   const [tempTraningList, setTempTraningList] = useState(
      noNeedToPageRefresh ? trainingListData : [],
   );
   const [selectedTab, setSelectedTab] = useState(
      noNeedToPageRefresh ? isValidRecord : VALID,
   );
   const [isApiLoading, setIsApiLoading] = useState(false);
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const authNewData = useSelector(selectAuthData);

   const [authData, setAuthData] = useState(
      noNeedToPageRefresh ? mAuthData : {},
   );
   const selectedTraining = useSelector(getSelectedTrainingRecord);
   const dispatch = useDispatch();
   const isWindows = Platform.OS === 'windows';

   useEffect(() => {
      if ((isWindows && isScreenFocused) || !isWindows) {
         if (isWindows && noNeedToPageRefresh) {
            return;
         }
         (async () => {
            if (isNewAPI) {
               if (isWindows) {
                  dispatch(setTrAuthData(authNewData));
               }
               // setTraningList(
               //    // authNewData.userRecords.filter(authData => authData.isValid),
               setAuthData(authNewData);
               callTrainingApi(selectedTraining);
               // );
            } else {
               const authData = await retrieveAppData(AUTHDATA);
               const data = JSON.parse(authData);
               setTraningList(data.userRecords?.filter(data => data.isValid));
               setAuthData(data);
               if (isWindows) {
                  dispatch(setTrAuthData(data));
                  dispatch(setTrainingListData(data.userRecords));
               }
            }
         })();
      }
   }, []);

   function handleCheckClick() {
      const rem = !checked ? 'true' : 'false';
      setChecked(!checked);
   }

   function filterList(filterRef) {
      setSelectedTab(filterRef);
      if (isWindows) {
         dispatch(setTrIsValidRecord(filterRef));
      }
      if (filterRef === All) {
         setTraningList(tempTraningList);
      } else if (filterRef === VALID) {
         setTraningList(tempTraningList?.filter(data => data.IsValid));
      }
   }

   function searchFilterList(text) {
      const list = traningList?.filter(function (item) {
         // Applying filter for the inserted text in search bar
         const itemData = item.coursename
            ? item.coursename.toUpperCase()
            : ''.toUpperCase();
         const textData = text.toUpperCase();
         return itemData.indexOf(textData) > -1;
      });
      setTraningList(list);
   }

   const handlePress = () => {
      logger('menu');
      setShowView(!showView);
      Animated.timing(animatedValue, {
         toValue: showView ? -1000 : 0,
         duration: 300,
         useNativeDriver: false,
      }).start();
   };

   function callTrainingApi(text) {
      if (isWindows) {
         dispatch(setSelectedTrainingRecord(text));
      }
      var api = '';
      if (text === IBTRecords) {
         api = TRAINING_IBT_RECORDS;
      } else if (text === ExternalRecords) {
         api = TRAINING_EXTERNAL_RECORDS;
      } else if (text === ThirdPartyRecords) {
         api = TRAINING_THIRDPARTY_RECORDS;
      } else if (text === TrainingOJTRecords) {
         api = TRAINING_OJT_RECORDS;
      } else if (text === TrainingAllRecords) {
         api = TRAINING_ALL_RECORDS;
      }
      (async () => {
         const reqParms = {
            theData: JSON.stringify({
               EmployeeKey: authNewData.EmployeeKey,
            }),
         };
         setIsApiLoading(true);
         apiPostRequest({url: api, parms: reqParms})
            .then(res => {
               setIsApiLoading(false);
               if (
                  res !== null &&
                  res !== undefined &&
                  typeof res !== 'string'
               ) {
                  // logger('TrainingData::', JSON.stringify(res));
                  // setCourseList(res.UserTrainingEnrolledRecordsList);
                  // setTempCourseList(re.UserTrainingEnrolledRecordsLists);
                  var responseValue = res.UserTrainingRecordsList;
                  if (text === IBTRecords) {
                     responseValue = res.UserTrainingRecordsList.filter(
                        data =>
                           data.CurrentStatus != '0 -ENR' &&
                           data.CurrentStatus != '1 -SES',
                     );
                  }
                  if (text === TrainingAllRecords) {
                     responseValue = responseValue.filter(
                        data =>
                           (data.CourseType === 'IBT' &&
                              data.CurrentStatus != '0 -ENR' &&
                              data.CurrentStatus != '1 -SES') ||
                           data.CourseType !== 'IBT',
                     );
                  }
                  if (isWindows) {
                     dispatch(setTrainingListData(responseValue));
                  }
                  setTempTraningList(responseValue);
                  // var li = res.UserTrainingRecordsList.filter(data => {
                  //   logger(data.CourseType);
                  //   data.CourseType === 'IBT';
                  // });
                  // logger(li);
                  const filterRecords =
                     selectedTab === 1
                        ? responseValue?.filter(data => data.IsValid)
                        : responseValue;
                  setTraningList(filterRecords);
                  // logger(res.UserTrainingRecordsList);
               } else {
                  if (isWeb) {
                     showTokenExpireAlertWeb(res);
                  } else {
                     alert(res);
                  }
               }
            })
            .catch(err => logger({err}));
      })();
   }

   return (
      <View
         style={[
            styles.container,
            {
               ...Platform.select({
                  web: {
                     flex: null,
                     //height: '100vh',
                     height: !isLandscapemode
                        ? isLandscapeSmallWebView
                           ? '100%'
                           : '100vh'
                        : '100vh',
                     minHeight: isLandscapeSmallWebView ? '100vh' : null,
                     overflowY: isLandscapemode ? 'hidden' : null,
                  },
               }),
            },
         ]}>
         {!isLandscapemode ? (
            <ApplicationHeader
               OnBackPress={() => {
                  navigation.goBack();
               }}
            />
         ) : (
            <Landscap_Application_Header
               authData={authData}
               selectedTab={MYTRAINING}
               onTopMenuClick={value => {
                  if (value === DASHBOARD) {
                     navigation.navigate('DashboardScreen');
                  } else if (value === MYTRAINING) {
                     navigation.navigate('MyTraningScreen');
                  } else if (value === PROFILE) {
                     navigation.navigate('ProfileScreen');
                  } else if (value === BROUS) {
                     navigation.navigate('BrowsesCoursesScreen');
                  }
               }}
               dataSource={['View Profile', 'Edit Profile', 'Logout']}
            />
         )}
         {!isLandscapemode ? (
            <View style={{flex: 1}}>
               <ProfileHeader
                  title="My Training"
                  subTitle={`Viewing ${
                     selectedTab === All ? 'All' : 'Valid'
                  } Training Records`}
                  trainigRecords={traningList?.length}
                  icon={require('../../assets/my_training.png')}
                  authData={authData}
                  isMyTraning={true}
                  onFilterClick={filterRef => {
                     filterList(filterRef);
                  }}
                  filterMytrainingData={filterText =>
                     callTrainingApi(filterText)
                  }
                  onQrClick={() => {
                     // To do , uncomment below line and remove handlePress(); call
                     navigation.navigate('QRAndBarcodeScreen', {
                        norcatID: getNorcatId(authData),
                        qrID: getQRCode(authData), //authData.QRID,
                     });
                  }}
               />
               {isApiLoading === false && traningList?.length === 0 ? (
                  <View
                     style={{
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: 32,
                     }}>
                     <Text
                        style={{
                           textAlign: 'center',
                        }}>
                        NO DATA AVAILABLE
                     </Text>
                  </View>
               ) : (
                  <TraningList
                     myTraningList={traningList}
                     navigation={navigation}
                     loading={isApiLoading}
                  />
               )}
            </View>
         ) : (
            <View
               style={{
                  flexDirection: 'row',
                  flex: 1,
                  ...Platform.select({
                     web: {
                        maxHeight: isLandscapemode ? '90vh' : null,
                     },
                  }),
               }}>
               <View style={{flex: 1}}>
                  <DashboardHeaderLandsacap
                     subtitle={selectedTab == 2 ? VIEWALL : VIEWVALID}
                     selectedTab={selectedTab}
                     trainingFilleter={selectedTraining}
                     icon={require('../../assets/my_training.png')}
                     title="My Training"
                     showCourses={true}
                     trainigRecords={traningList?.length}
                     showSearchView={Platform.OS === 'web' ? false : false}
                     showFilterTabs={false}
                     showRecordTabs={true}
                     isMyTraning={true}
                     showFooter={true}
                     showRefreshIcon={false}
                     filterMytrainingData={filterText =>
                        callTrainingApi(filterText)
                     }
                     onFilterClick={filterRef => {
                        filterList(filterRef);
                     }}
                     onSearch={text => {
                        searchFilterList(text);
                     }}
                     authData={authData}
                  />
                  {isApiLoading === false && traningList?.length === 0 ? (
                     <View
                        style={{
                           flex: 1,
                           alignItems: 'center',
                           justifyContent: 'center',
                           marginTop: 32,
                        }}>
                        <Text
                           style={{
                              textAlign: 'center',
                           }}>
                           NO DATA AVAILABLE
                        </Text>
                     </View>
                  ) : (
                     <TraningList
                        myTraningList={traningList}
                        navigation={navigation}
                        loading={isApiLoading}
                     />
                  )}
               </View>
               <View
                  style={{
                     flex: 0.4,
                     ...Platform.select({
                        web: {
                           flex: isLandscapemode ? null : 0.4,
                           width: isLandscapemode ? '30%' : null,
                           height: isLandscapemode ? '90vh' : null,
                        },
                     }),
                  }}>
                  <DashboardRightPanel
                     showProgressView={false}
                     showName={true}
                     authData={authData}
                     height={advtsHeight}
                     onQrClick={() => {
                        navigation.navigate('QRAndBarcodeScreen', {
                           norcatID: getNorcatId(authData),
                           qrID: getQRCode(authData), //authData.QRID,
                        });
                     }}
                  />
               </View>
            </View>
         )}
      </View>
   );
};

const TraningList = ({myTraningList, navigation, loading}) => {
   const dispatch = useDispatch();
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const windowHeight = isWeb
      ? window.innerHeight
      : Dimensions.get('window').height;
   const trainingListHeight =
      windowHeight < 780
         ? // Medium size Desktop/Tablet
           windowHeight < 680
            ? windowHeight < 600
               ? windowHeight * 0.58
               : windowHeight * 0.645
            : windowHeight < 701
            ? windowHeight * 0.66
            : windowHeight < 750
            ? windowHeight * 0.69
            : windowHeight * 0.67
         : // Large size Desktop
         windowHeight > 1000
         ? windowHeight * 0.78
         : windowHeight * 0.72;
   logger({windowHeight});
   return (
      <ContainerWrapper loading={loading}>
         <View
            style={{
               flex: 1,
               marginTop: 12,
            }}>
            <FlatList
               data={myTraningList}
               contentContainerStyle={{
                  paddingBottom: 20,
                  ...Platform.select({
                     web: {
                        paddingBottom: isLandscapeMode ? 0 : 20,
                     },
                  }),
               }}
               renderItem={({item}) => (
                  <MyTrainingItem
                     item={item}
                     isLandscap={isLandscapeMode}
                     onItemClick={() => {
                        const userRecord = {userRecord: item};
                        dispatch(setUserRecord(userRecord));
                        navigation.navigate('RecordDetailsScreen');
                     }}
                  />
               )}
               numColumns={1}
            />
         </View>
      </ContainerWrapper>
   );
};

const styles = StyleSheet.create({
   container: {
      backgroundColor: appBackgroundWhiteBG,
      flex: 1,
      paddingBottom: 0,
   },
   inputStyle: {
      width: '100%',
      height: 40,
      backgroundColor: white,
      marginTop: 8,
      borderWidth: 1,
      paddingHorizontal: 14,
      borderColor: '#AFBACA',
      borderRadius: 6,
      justifyContent: 'center',
   },
   textStyle: {
      fontSize: 14,
      color: base100,
      fontWeight: '700',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   titleStyle: {
      fontSize: 14,
      marginTop: 16,
      color: '#3D4A5C',
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   profileStyle: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      flexDirection: 'column',
   },
   profileStyleLandscap: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      flexDirection: 'row',
   },
});

export default MyTrainingScreen;
